// Heavy Machinery inner page — Industries tile 02.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function Machinery() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.machinery}
        eyebrow="Industries · Heavy Machinery"
        headline="AI that extends your"
        italicWord="assets."
        lede="We connect AI to your machinery fleet so your operators see problems before they become failures."
      />

      <section className="bg-black py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6">

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What we build</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Sensor fusion, anomaly detection, operator copilots.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              We aggregate data from your existing sensors, telematics and maintenance records into a
              unified AI model that learns normal operating behaviour and flags deviations early.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              Operator-facing copilots surface recommendations in plain language at the point of
              decision. Not a back-office dashboard. A tool the operator actually opens.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work with machinery clients</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Your existing sensors are the starting point.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              We start by inventorying your data sources: CAN bus, SCADA, telematics, maintenance
              records. We assess data quality and identify the gaps we need to fill before a model
              will perform reliably.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We build incrementally. A pilot on your highest-value assets, validated over four to
              eight weeks, before scaling across the fleet. You see results before you make a large
              commitment.
            </p>
          </Reveal>

          <div className="hairline my-16" />

          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Unplanned downtime is your biggest cost.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You manage a fleet of high-value assets where a single unplanned failure costs tens of
              thousands in lost production or emergency repair. You want earlier warning than your
              current maintenance schedule provides.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              You want AI that integrates with your existing workshop and maintenance workflows, not
              a new system your team has to learn alongside their existing tools.
            </p>
          </Reveal>

        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
